<template>
  <ServicePageLayout
    title="Alert"
    subtitle="ประวัติการแจ้งเตือน"
    icon="mdi-alert-outline"
    breadcrumb="Operations"
  >
    <v-card flat class="service-content-panel">
      <v-card-text>
        <ALERT_DATATABLE />
      </v-card-text>
    </v-card>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import ALERT_DATATABLE from '@/components/alerts/alert_datatable'

export default {
  name: 'AlertView',
  components: {
    ServicePageLayout,
    ALERT_DATATABLE
  },
}
</script>
